<template>
    <div class="footer fc-ac-jc">
        <div
            class="pb-30 fc-js w-65 mb-30"
            style="border-bottom: 1px solid #4c4c4c"
        >
            <div class="mb-7 fs-18" style="color: #fff">官方网站链接</div>
            <div class="fr-ac">
                <div
                    v-for="(item, ind) in foot.list"
                    :key="ind"
                    class="mr-20 listItem"
                    @click="pathOutClick(item)"
                >
                    {{ item.title }}
                </div>
            </div>
        </div>
        <div
            class="mb-5 listItem"
            @click="pathOutClick({ link: `/school/contact` },1)"
        >
            {{ foot.lxwm }}
        </div>
        <div class="mb-5">{{ foot.bq }}</div>
        <div
            class="mb-5 listItem"
            @click="
                pathOutClick({
                    link: 'https://beian.miit.gov.cn/#/Integrated/index',
                })
            "
        >
            {{ foot.beian }}
        </div>
        <div class="mb-5">{{ foot.dw }}</div>
    </div>
</template>
<script>
export default {
    name: "FooterView",
    components: {},
    data() {
        return {};
    },
    computed: {
        foot() {
            return {
                ...this.$store.state.page_one.list_foot,
                list: [
                    {
                        title: "教育部",
                        link: "http://www.moe.gov.cn/",
                    },
                    {
                        title: "教育部阳光高考信息平台",
                        link: "https://gaokao.chsi.com.cn/",
                    },
                    {
                        title: "福建省教育厅",
                        link: "https://jyt.fujian.gov.cn/",
                    },
                    {
                        title: "福建省教育考试院",
                        link: "https://www.eeafj.cn/",
                    },
                    // {
                    //     title: "高宏教育",
                    //     link: "https://www.gaohongedu.net/",
                    // },
                ],
                lxwm: "联系我们",
                bq: `Copyright \u00A9 2017 - ${new Date().getFullYear()} gkzzd.cn All rights reserved.版权所有 高考早知道`,
                dw: "福建互联网协会理事单位",
            };
        },
    },
    watch: {},
    methods: {
        async pathOutClick(val, type) {
            switch (type) {
                case 1:
                    window.open(`${process.env.VUE_APP_OUT_URL}${val.link}`, "_blank");
                    break;
                default:
                    window.open(val.link, "_blank");
                    break;    
            }
        },
    },
    created() {},
    mounted() {},
    beforeCreate() {},
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.footer {
    background-color: #3c3c3c;
    padding: 30px 0;
    color: #999;
    
    .listItem {
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>